export var OutstreamDemandProvider;
(function (OutstreamDemandProvider) {
    OutstreamDemandProvider["direct"] = "direct";
    OutstreamDemandProvider["prebid"] = "prebid";
    OutstreamDemandProvider["tam"] = "tam";
})(OutstreamDemandProvider || (OutstreamDemandProvider = {}));
// Single source of truth for the outstream player size. The demand request
// (Prebid/TAM), the IMA render slot, and the injected player CSS box all derive
// from this so a bid won at this size renders at this size.
export const DEFAULT_OUTSTREAM_SIZE = { width: 640, height: 480 };
